<template>
  <v-navigation-drawer
    :value="isOpenTemplateEventDetail"
    :permanent="isOpenTemplateEventDetail"
    temporary
    fixed
    right
    width="600"
    max-width="100vw"
    style="transition: 0.5s cubic-bezier(0.4, 0, 0.2, 1);"
    color="grey lighten-3"
  >
    <v-card v-if="templateEvent.id" min-height="100vh" color="grey lighten-3">
      <BaseToolbar
        title="Detalles de evento"
        type-title="text"
        :button-save="false"
        @close="close"
      >
        <div class="d-flex align-center pr-4">
          <v-btn
            rounded
            color="primary"
            @click="editEvent()"
            v-text="$t('general.edit')"
          />
        </div>
      </BaseToolbar>
      <v-card-text class="pa-0" style="overflow-y: auto;height: calc(100vh - 64px)">
        <v-container class="py-10">
          <v-row justify="center">
            <v-col cols="12" md="10">
              <v-card>
                <v-card-text class="pa-4">
                  <v-row>
                    <v-col cols="6">
                      <div
                        class="subtitle-2 primary--text mb-1"
                        v-text="$t('template_events.fields.type')"
                      />
                      <div v-text="templateEvent.type" class="subtitle-1" />
                    </v-col>
                    <v-col cols="6">
                      <div
                        class="subtitle-2 primary--text mb-1"
                        v-text="$t('template_events.fields.account_type')"
                      />
                      <div v-text="templateEvent.account_type" class="subtitle-1" />
                    </v-col>
                    <v-col cols="6">
                      <div
                        class="subtitle-2 primary--text mb-1"
                        v-text="$t('template_events.fields.module')"
                      />
                      <div v-text="templateEvent.module_id" class="subtitle-1" />
                    </v-col>
                    <v-col cols="12">
                      <div
                        class="subtitle-2 primary--text mb-1"
                        v-text="$t('template_events.fields.name')"
                      />
                      <div v-text="templateEvent.name" class="subtitle-1" />
                    </v-col>
                    <v-col cols="12">
                      <div
                        class="subtitle-2 primary--text mb-1"
                        v-text="$t('template_events.fields.description')"
                      />
                      <div v-text="templateEvent.description" class="subtitle-1" />
                    </v-col>
                    <v-col cols="12">
                      <div
                        class="subtitle-2 primary--text mb-1"
                        v-text="$t('template_events.fields.status')"
                      />
                      <div v-text="templateEvent.status" class="subtitle-1" />
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col cols="12" md="10">
              <v-card>
                <v-card-title>
                  {{ $t('template_events.fields.variables') }}
                </v-card-title>
                <v-card-text>
                  <v-row dense>
                    <v-col v-if="!templateEvent.variables.length" cols="12">
                      <v-chip class="d-block text-center">
                        <div
                          class="d-flex align-center"
                          v-text="$t('template_events.fields.not_found_variables')"
                        />
                      </v-chip>
                    </v-col>
                    <v-col
                      v-for="(item, index) in templateEvent.variables"
                      :key="index"
                      cols="6"
                      md="4"
                    >
                      <v-chip class="d-block pr-8">
                        <div class="d-flex align-center text-truncate" v-text="item" />
                      </v-chip>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
    </v-card>
  </v-navigation-drawer>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import BaseToolbar from '@/components/BaseToolbar'
export default {
  components: {
    BaseToolbar
  },
  data () {
    return {
      loading: false
    }
  },
  computed: {
    ...mapGetters({
      isOpenTemplateEventDetail: 'templateEvents/isOpenTemplateEventDetail',
      templateEvent: 'templateEvents/templateEvent'
    })
  },
  methods: {
    ...mapActions({
      getTemplateEvent: 'templateEvents/getTemplateEvent'
    }),
    ...mapMutations({
      setEditorMode: 'templateEvents/setEditorMode',
      toggleTemplateEventDetail: 'templateEvents/toggleTemplateEventDetail',
      toggleTemplateEventEditor: 'templateEvents/toggleTemplateEventEditor'
    }),
    cleanData () {
      this.loading = false
    },
    close () {
      this.toggleTemplateEventDetail(false)
      this.cleanData()
    },
    async editEvent (id) {
      this.setEditorMode('edit')
      this.toggleTemplateEventDetail(false)
      this.toggleTemplateEventEditor(true)
    }
  }
}
</script>
